module.exports = __webpack_public_path__ + "img/progress_093.8dae3c86.png";